export default "__VITE_ASSET__BhKny35x__"